import React, { useCallback, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import fiftycents from '../img/videos/50cents.png';
import british from '../img/videos/british.png';
import play from '../img/videos/play.svg';
import spanish from '../img/videos/spanish.png';
import tiff from '../img/videos/tiff.png';

const Video = React.memo(({ img, url, size, openModal }) => {
  const handleClick = useCallback(() => openModal(url), [openModal, url]);
  const className = useMemo(
    () =>
      `cursor-pointer rounded transition-all duration-500 ease-in-out 
    group-hover:mx-[20px] group-hover:scale-125 ${size}`,
    [size]
  );
  return (
    <div className="group rounded">
      <div className="group relative">
        <img src={img} alt="video" className={className} onClick={handleClick} />
        <img
          src={play}
          alt="play"
          className="pointer-events-none absolute left-1/2 top-1/2 size-[196px] -translate-x-1/2 -translate-y-1/2 transform opacity-0 transition-opacity duration-200 group-hover:opacity-50"
        />
      </div>
    </div>
  );
});

Video.propTypes = {
  img: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
};

export const Videos = React.memo(() => {
  const [modalVideo, setModalVideo] = useState(null);

  const videos = [
    {
      img: fiftycents,
      url: 'https://www.youtube.com/embed/rtGopi3x_88?si=8_vCAQB867emtVWr&amp;controls=0',
      size: 'max-w-[248px] max-h-[442px]',
    },
    {
      img: tiff,
      url: 'https://www.youtube.com/embed/uW1Enf1diDQ?si=uP2h_B-y151Xzy4O&amp;controls=0&amp;start=128',
      size: 'max-w-[327px] max-h-[582px]',
    },
    {
      img: british,
      url: 'https://www.youtube.com/embed/n-nJgjdWh58?si=_iv2Ei8YXYSQ_rxd&amp;controls=0',
      size: 'max-w-[248px] max-h-[442px]',
    },
    {
      img: spanish,
      url: 'https://www.youtube.com/embed/-E7Kq-Mp3ik?si=XanrqLunqjt7cdW9&amp;controls=0',
      size: 'max-w-[150px] max-h-[265px]',
    },
  ];

  const openModal = useCallback((url) => {
    setModalVideo(url);
  }, []);

  const closeModal = useCallback(() => {
    setModalVideo(null);
  }, []);

  const stopPropagation = useCallback((e) => e.stopPropagation(), []);

  return (
    <div id="videos" className="overflow-hidden">
      <div className="mb-[76px] mt-[90px] flex flex-col items-center justify-center gap-[30px] md:flex-row">
        {videos.map((video, index) => (
          <Video key={index} {...video} openModal={openModal} />
        ))}
      </div>

      {modalVideo && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
          onClick={closeModal}
        >
          <div
            className="relative h-[450px] w-[90%] max-w-[800px] rounded bg-black shadow-lg"
            onClick={stopPropagation}
          >
            <button
              className="absolute right-2 top-2 z-10 flex size-8 items-center justify-center rounded-full bg-primary-600 font-bold text-white"
              onClick={closeModal}
            >
              ✕
            </button>
            <iframe
              src={`${modalVideo}&autoplay=1`}
              title="YouTube video player"
              width="100%"
              height="100%"
              className="rounded"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
});
